import { SignUp } from "@clerk/clerk-react";

export function SignUpRoute() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
    </div>
  );
}
